import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";
import eye from "assets/images/ct/they-know-eye.png";
import line from "assets/images/ct/question/que-line.png";
import dice from "assets/images/ct/question/dice-arrow.png";
import checkIcon from "assets/images/ct/question/green-check.png";
import crossIcon from "assets/images/ct/question/cross.png";
import searchIcon from "assets/images/ct/question/search-icon.png";
import dice1 from "assets/images/ct/dice1.png";
import dice2 from "assets/images/ct/dice2.png";
import dice3 from "assets/images/ct/dice3.png";
import dice4 from "assets/images/ct/dice4.png";
import dice5 from "assets/images/ct/dice5.png";
import dice6 from "assets/images/ct/dice6.png";
import dicearrow from "assets/images/ct/dice-arrow.png";
import {
  divVariants,
  fadeVariants,
  slide_bounce_down_variants,
  staticBounceVariants
} from "shared/components/animations";
const CTTurnResult = ({
  roomId,
  screens,
  chosen_answer,
  correct_answer,
  isActivePlayer,
  isReaderPlayer,
  currentPlayer,
  category,
  answers,
  question,
  dicedata,
  buzzer_sound,
  default_audio_effect
}) => {
  const correctlyAnswered = chosen_answer === correct_answer;
  const [counter, setCounter] = useState(10);

  const active_right = _.get(
    screens,
    "5_turnresult.active.right",
    "You got it right, keep the card!"
  );
  const active_right_title = _.get(
    screens,
    "5_turnresult.active.right_title",
    "NICE"
  );
  const active_wrong = _.get(
    screens,
    "5_turnresult.active.wrong",

    "Sorry, looks like you missed it. Kiss the card goodbye."
  );
  const active_wrong_title = _.get(
    screens,
    "5_turnresult.active.wrong_title",

    "NOPE"
  );
  const nonactive_right = _.get(
    screens,
    "5_turnresult.nonactive.right",

    "They got it right, and get to keep the card!"
  );
  const nonactive_right_title = _.get(
    screens,
    "5_turnresult.nonactive.right_title",
    "NICE"
  );
  const nonactive_wrong = _.get(
    screens,
    "5_turnresult.nonactive.wrong",

    "They got it wrong, they don't get to keep the card!"
  );
  const nonactive_wrong_title = _.get(
    screens,
    "5_turnresult.nonactive.wrong_title",

    "NOPE"
  );

  useEffect(() => {
    if (isActivePlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);
  useEffect(() => {
    let timer;
    timer =
      isActivePlayer &&
      counter > 0 &&
      setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onUpdateStatus("update");
    return () => clearInterval(timer);
  }, [counter, isActivePlayer]);

  const buttonPressAction = () => {
    const data = {
      action: "special-action",
      roomId,
      playerId: currentPlayer?.player_id,
      specialAction: "End Turn"
    };
    Socket.sendMessage(data);
  };

  const onUpdateStatus = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );
  const diceValue = (type) => {
    switch (type) {
      case 1:
        return dice1;

      case 2:
        return dice2;
      case 3:
        return dice3;
      case 4:
        return dice4;
      case 5:
        return dice5;

      default:
        return dice6;
    }
  };

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="ct-question"
    >
      <motion.div variants={fadeVariants} className="ct-question-type">
        <img src={eye} className="img-fluid" alt="" />
        <div className="type">
          <h2>{correctlyAnswered ? active_right_title : active_wrong_title}</h2>
          <img src={line} className="img-fluid underline" alt="" />
        </div>
        <div className="dice">
          <img src={diceValue(dicedata?.dice[0])} alt="dicesketch" />
          <img src={diceValue(dicedata?.dice[1])} alt="dicesketch" />
          <img src={dicearrow} className="dice-arrow" alt="dicearrow" />
        </div>
      </motion.div>
      {isActivePlayer && (
        <motion.p variants={fadeVariants} className="question">
          {correctlyAnswered ? active_right : active_wrong}
        </motion.p>
      )}

      {!isActivePlayer && (
        <motion.p variants={fadeVariants}>
          {correctlyAnswered
            ? nonactive_right
            : nonactive_wrong}
        </motion.p>
      )}
      <motion.div
        variants={slide_bounce_down_variants}
        className="options-wrapper"
      >
        <div className="option-type">
          <div className="green-bg">
            <h2>{category}</h2>
          </div>
        </div>
        <div className="options-card">
          <p className="que">{question}</p>
          <div className="ans-flex">
            <p className="ans">{answers[correct_answer]}</p>
            <div className="img-div">
              <img src={checkIcon} className="img-fluid" alt="" />
            </div>
          </div>
          {!correctlyAnswered && (
            <div className="ans-flex">
              <p className="ans">{answers[chosen_answer]}</p>
              <div className="img-div">
                <img src={crossIcon} className="img-fluid" alt="" />
              </div>
            </div>
          )}
        </div>
      </motion.div>

      <motion.div variants={staticBounceVariants} className="result-buttons">
        {isActivePlayer && !correctlyAnswered && (
          <button className="learn-btn">
            <img src={searchIcon} className="img-fluid" alt="" />
            <br />
            Learn the conspiracy!
          </button>
        )}
        {!isActivePlayer && (
          <button className="learn-btn">
            <img src={searchIcon} className="img-fluid" alt="" />
            <br />
            Learn the conspiracy!
          </button>
        )}

        {isActivePlayer && (
          <button
            className="ct-btn-green confirm-btn"
            onClick={onUpdateStatus}
          >{`confirm  (${counter})`}</button>
        )}
      </motion.div>
    </motion.div>
  );
};

export default CTTurnResult;
